export default __webpack_public_path__ + "static/media/node.c580880c.png";